<template>
  <div :class="$style.container">
    <div
      :class="[$style.progressBar, {
        [$style.secondary]: isSecondary,
      }]"
    >
      <div
        :class="[$style.progressBarProgress, {
          [$style.secondaryFill]: isSecondary,
        }]"
        :style="{ width: `${100 * numComplete / numItems}%` }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',

  props: {
    isSecondary: {
      type: Boolean,
      default: false,
    },
    numComplete: {
      type: Number,
      default: 0,
    },
    numItems: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style module>
.container {
  padding: var(--jc-spacer);
}

.progressBar {
  background-color: var(--jcWhite50);
  border-radius: 6px;
  height: 8px;
  position: relative;
  width: 100%;
}

.progressBarProgress {
  background-color: var(--jcPrimary);
  border-radius: var(--jc-border-radius);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
}

.secondary {
  background-color: var(--jcGrey200);
}

.secondaryFill {
  background-color: var(--jcPrimary);
}
</style>
